const number = new Intl.NumberFormat("cs-CZ");

export const formatNumber = (n) => number.format(Number(n) || 0);
export const formatPrice = (n) => `${formatNumber(n)} Kč`;
export const priceWithoutVat = (n) => Math.round((Number(n) || 0) / 1.21);
export const formatKm = (n) => `${formatNumber(n)} km`;

// Budget caps offered by the stock search (home + inventory).
export const PRICE_CAPS = [500000, 750000, 1000000, 1500000, 2000000];

// The DB stores condition in English (admin form values).
const CONDITIONS = { "Like New": "Jako nový", "Excellent": "Výborný", "Very Good": "Velmi dobrý", "Good": "Dobrý" };
export const conditionLabel = (c) => CONDITIONS[c] || c || "";

export const carTitle = (car) => `${car.brand} ${car.model}`;

/** /nabidka/12-tesla-model-3 — the id is what matters, the slug is for people and SEO. */
export function carPath(car) {
  const slug = carTitle(car)
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  return `/nabidka/${car.id}-${slug}`;
}

export const carStatus = (car) => (car.sold ? "sold" : car.reserved ? "reserved" : "available");
